/** Created by azhou on 2019/3/15.*/
<template>
  <div>
    <public-title>消息详情
      <span slot="right" class="text-link ml-auto h6" @click="$router.back()">返回列表</span>
    </public-title>
    <div class="bg-white text-center">
      <h3 class="pt-4">{{msgDetail.title}}</h3>
      <div class="mt-3 text-muted">{{msgDetail.add_time | formatTimestamp(1)}}</div>
      <p class="text-left pt-3 pl-5 pr-5 pb-5 h5">{{msgDetail.content}}</p>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'

  export default {
    name: 'MsgDetail',
    computed: {
      ...mapState(['msgDetail'])
    },
    methods:{
      ...mapActions(['getMsgDetail','readMsg'])
    },
    async created() {
      await this.getMsgDetail(this.$route.query.id);
      // if (this.msgDetail.is_read==1) this.readMsg({
      //   // msg_id:this.$route.query.id,
      //   msg_type:this.msgDetail.type
      // })
    }
  }
</script>

<style lang="scss" scoped>
p{
  line-height: 30px;
  text-indent: 2em
}
</style>